import { cn } from '@/lib/helpers/utils';
import React from 'react';
type Props = {
  bkgColor?: string;
  width?: 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | 'full' | 'custom';
  disableIndent?: boolean;
  disableSuppression: boolean;
  containerClass?: string;
  children: any;
  'data-cy': any;
};

export const SectionContainer = (props: any) => {
  const configurationProps: Props = {
    ...{
      bkgColor: '',
      width: '2xl',
      disableIndent: false,
      disableSuppression: false,
      containerClass: ''
    },
    ...props
  };

  let sectionContainerClass = 'section-container-full';
  switch (configurationProps.width) {
    case 'md':
      sectionContainerClass = 'section-container';
      break;
    case 'lg':
      sectionContainerClass = 'section-container-lg';
      break;
    case 'xl':
      sectionContainerClass = 'section-container-xl';
      break;
    case '2xl':
      sectionContainerClass = 'section-container-2xl';
      break;
    case '3xl':
      sectionContainerClass = 'section-container-3xl';
      break;
    case '4xl':
      sectionContainerClass = 'section-container-4xl';
      break;
    case 'custom':
      sectionContainerClass = '';
    default:
      break;
  }

  const sectionContainerClasses = cn(
    configurationProps.bkgColor ? configurationProps.bkgColor : '',
    sectionContainerClass ? sectionContainerClass : '',
    configurationProps.width !== 'full'
      ? `${!configurationProps.disableSuppression ? `suppress-section-container-padding` : ``}`
      : '',
    !configurationProps.disableIndent ? 'section-container-indent' : '',
    configurationProps.containerClass ? configurationProps.containerClass : ''
  );
  return (
    <div className={sectionContainerClasses} data-cy={props['data-cy'] ? props['data-cy'] : null}>
      {props.children}
    </div>
  );
};
